<template>
    <dashboard-layout>

        <section class=" d-table w-100" id="home" v-if="subscribe != null">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-lg-7 col-md-7">
                        <div class="title-heading mt-4">
                            <h1 class="heading mb-3">
                                {{ subscribe.course?.name }}
                            </h1>
                            <p class="para-desc text-muted">
                                You'r subscribed will expire in {{ subscribe.end_date }}.
                                <br>
                                <template v-if="subscribe.course_status == 'Active'">
                                    <span class="badge badge-success">Active</span>
                                    you can access to all content.
                                </template>
                                <template v-else>
                                    <span class="badge bg-soft-danger">Inactive</span>
                                </template>
                            </p>
                            <div class="mt-4 pt-2">
                                <router-link :to="{name: 'courses.show', params: { id: subscribe.course?.id ?? 0 }}" class="btn btn-primary " target="_blank">
                                    Course page
                                </router-link>
                            </div>
                        </div>
                    </div><!--end col-->

                    <div class="col-lg-5 col-md-5 mt-4 pt-2 mt-sm-0 pt-sm-0 text-center">
                        <img :src="subscribe.course?.image" alt="" class="mw-100 rounded" style="max-width: 360px;">
                    </div><!--end col-->
                </div><!--end row-->
            </div><!--end container-->
        </section>

        <div class="row">
            <div class="col-lg-8 mt-4">


                <router-link
                    :to="{name: 'questions.courses.filter', params: { 'subscribe_id': $route?.params?.subscribe_id }}"
                >
                    <div class="card border-0 rounded shadow p-4 mb-3">
                        <div class="d-flex justify-content-between align-items-center mb-4 border-bottom  pb-3">
                            <div class="">
                                <h6 class="mb-0">Question bank</h6>
                            </div>
                            <div class="">
                                <i class="ti ti-settings btn btn-outline-light"></i>
                            </div>
                        </div>
                        <div class="">
                            <div class="d-flex mb-3">
                                <h5 class="me-2">All categories </h5>
                                <span class="btn btn-outline-light btn-sm">Change</span>
                            </div>

                            Last attempted:
                            <span class="text-muted">
                                {{ sessions?.data && sessions?.data[0]?.ago }}
                            </span>
                        </div>
                    </div>
                </router-link>

            </div>
            <div class="col-lg-4 mt-4">
                <div class="card border-0 rounded shadow p-4 mb-3">
                    <div class="d-flex justify-content-between align-items-center">
                        <div class="d-flex align-items-center">
                            <div class="flex-1 ms-2">
                                <h6 class="mb-0">Last sessions</h6>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex justify-content-between align-items-center" v-for="session in sessions?.data"
                         :key="session.id">

                        <router-link :to="{name: 'question_sessions.show', params: { session_id: session.id }}"
                                     class="d-flex align-items-center mt-4">
                            <!--                                    <img src="assets/images/client/06.jpg" class="avatar avatar-md-sm rounded-circle border shadow" alt="">-->
                            <div class="flex-1 ms-2">
                                <h6 class="mb-0 text-dark">
                                            <span v-for="subject in session?.subjects" class="me-1">
                                                {{ subject.name }}
                                            </span>
                                    <span v-for="universitie in session?.universities" class="me-1">
                                                {{ universitie.name }}
                                            </span>
                                </h6>
                                <small class="text-muted">
                                    {{ session.ago }}
                                </small>
                            </div>
                        </router-link>

                        <a href="profile.html" class="text-primary"><i class="ti ti-arrow-right"></i></a>
                    </div>
                </div>
            </div>
        </div>
    </dashboard-layout>
</template>


<script>
import {useToast} from "vue-toastification";
import DashboardLayout from "../../dashboard-layout.vue";

const toast = useToast();

export default {
    components: {DashboardLayout},
    data() {
        return {
            sessions: [],
            subscribe: null,
        };
    },
    created() {
        console.log(this.$attrs);
        this.getSessions();
        this.getSubscribe();
    },
    methods: {
        getSessions(page = this.$route?.query?.page ?? 1) {

            const id = toast.info('Getting content ...', {icon: 'fa-solid fa-download'});

            axios.get('question_sessions', {params: {'subscribe_id': this.$route?.params?.subscribe_id}}).then(response => {
                toast.dismiss(id);
                this.sessions = response.data;
            }).catch(error => {
                toast.dismiss(id);
                toast.error(`Error: ${error.response ? error.response.data.message : 'An error occurred'}`);
            });

        },
        getSubscribe() {
            const id = toast.info('Getting content ...',{ icon: 'fa-solid fa-download' });

            axios.get(`subscriptions/${this.$route.params.subscribe_id}`, {}).then(response => {

                this.subscribe = response.data.data;

                toast.dismiss(id);
            }, response => {
                toast.dismiss(id);
            });
        },
    }
}
</script>
